import * as Yup from "yup";

import {SubscribersSettingsFormValues} from "@/pages/statuspages/tabs/subscribers/components/SubscribersSettingsForm/SubscribersSettingsForm.types.ts";

export const SubscribersSettingsFormDefaultValues: SubscribersSettingsFormValues = {
  allow_subscriptions_email: true,
  allow_subscriptions_rss: true,
  allow_subscriptions_slack: true,
  allow_subscriptions_sms: true,
  allow_subscriptions_webhook: true,
  allow_notifications: true,
  email_from: "",
  email_reply_to: "",
  contact_email: "",
};

export const SubscribersSettingsFormSchema: Yup.ObjectSchema<SubscribersSettingsFormValues> = Yup.object({
  allow_subscriptions_email: Yup.boolean().default(false).required(),
  allow_subscriptions_rss: Yup.boolean().default(false).required(),
  allow_subscriptions_slack: Yup.boolean().default(false).required(),
  allow_subscriptions_sms: Yup.boolean().default(false).required(),
  allow_subscriptions_webhook: Yup.boolean().default(false).required(),
  allow_notifications: Yup.boolean().default(true).required(),
  email_from: Yup.string().defined(),
  email_reply_to: Yup.string().defined(),
  contact_email: Yup.string().defined(),
});
